'use client'
import dynamic from 'next/dynamic'

const QuickActionsPanelClient = dynamic(() => import('./QuickActionsPanelClient'), {
  ssr: false,
  loading: () => null,
})

export default function QuickActionsPanelLazy() {
  return <QuickActionsPanelClient />
}
